let number = 0;

export const getId = () => `~m${(number += 1).toString(36)}`;
